import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoginNeotrade = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 7C1.44772 7 1 7.44772 1 8V16C1 16.5523 1.44772 17 2 17H5C5.55228 17 6 16.5523 6 16V8C6 7.44772 5.55228 7 5 7H2ZM2.5 8.5V15.5H4.5V8.5H2.5Z",
			fill: ""
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 3C7.5 2.44772 7.94772 2 8.5 2H11.5C12.0523 2 12.5 2.44772 12.5 3V16C12.5 16.5523 12.0523 17 11.5 17H8.5C7.94771 17 7.5 16.5523 7.5 16V3ZM9 15.5V3.5H11V15.5H9Z",
			fill: ""
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15 4C14.4477 4 14 4.44772 14 5V16C14 16.5523 14.4477 17 15 17H18C18.5523 17 19 16.5523 19 16V5C19 4.44772 18.5523 4 18 4H15ZM15.5 5.5V15.5H17.5V5.5H15.5Z",
			fill: ""
		})
	]
});
export default SvgLoginNeotrade;
